import { DateTime } from 'luxon'

export default {
  methods: {
    toDate: function(date) {
      if (date) {
        return DateTime.fromISO(date).toFormat('dd.MM.yyyy')
      }
    },

    toShortDate: function(date) {
      if (date) {
        return DateTime.fromISO(date).toFormat('dd.MM.')
      }
    },

    toTime: function(time) {
      if (time) {
        return DateTime.fromISO(time, { zone: 'GMT' }).setZone('Europe/Berlin').toFormat('HH:mm')
      }
    },
  },
};
